import Model from "../Model";

export default class extends Model {
  async loadTable(page, limit, search = '', params = {}) {
    let response = await super.list(page, limit, search, params).then(result => {return result});
    let result = {
      tbody: [],
      pages: response.pages,
    };
    if(response.items !== undefined && response.items.length > 0)
    {
      response.items.forEach(template => {
        let telem = {
          tbody: {}
        };
        telem.id = template.id;
        telem.tbody.name = template.name;
        telem.tbody.subject = template.subject;
        telem.tbody.sender_id = template.sender_id;
        telem.tbody.body = template.body;
        telem.tbody.favorite = template.favorite;
        telem.tbody.created_at = template.created_at;
        result.tbody.push(telem);
      });
    }
    return result;
  }
}
